<template>
    <div class="service">
        <h3>{{data["titre"]}}</h3>
        <!-- Bloc avec l'image, les informations générales sur le service-->
        <div class="meta_info">
            <div class="meta_info_left">
                <img v-if='image !== null' :src='image' alt="">
                <div class='image_null' v-if='image === null'>
                    <img :src="`${publicPath}${imagePath(data)}`" :alt="'Logo de la catégorie'">
                </div>
            </div>
            <div class="meta_info_right">
                <div v-if='getLabels(data["localisation"], "localisation") !== ""' class="meta_info_links">
                    <img src="../static/location.svg" alt="Icone lieu">
                    <p>{{getLabels(data["localisation"], "localisation")}}</p>
                </div>
                <div v-if='getPorteur(data) !== ""' class="meta_info_links">
                    <img src="../static/porteur.svg" alt="Icone porteur">
                    <p>{{getPorteur(data)}}</p>
                </div>
                <div v-if='getLabels(data["modalite"], "modalite") !== ""' class="meta_info_links">
                    <img src="../static/modalite.svg" alt="Icone modalité">
                    <p>{{getLabels(data["modalite"], "modalite")}}</p>
                </div>
                <div v-if='getLabels(data["public"], "public") !== ""' class="meta_info_links">
                    <img src="../static/public.svg" alt="Icone public">
                    <p>{{getLabels(data["public"], "public")}}</p>
                </div>
            </div>
        </div>

        <!-- Paragraphe de description de l'initiative-->
        <p class="description">{{data["descriptif"]}}</p>

        <!-- Champs spécifiques pour courses et manger local-->
        <div v-if='getCategorie(data) === "1"' class="alimentation_infos">
            <div v-if='getLabels(data["modalite_de_livraison"], "modalite_de_livraison") !== ""' class="small_alimentation_info">
                <img src="../static/livraison.svg" alt="Icone livraison">
                <p>{{getLabels(data["modalite_de_livraison"], "modalite_de_livraison")}}</p>
            </div>
            <div v-if='getLabels(data["mode_de_paiement"], "mode_de_paiement") !== ""' class="small_alimentation_info">
                <img src="../static/payement.svg" alt="Icone paiement">
                <p>{{getLabels(data["mode_de_paiement"], "mode_de_paiement")}}</p>
            </div>
            <div v-if='getLabels(data["type_de_produit"], "type_de_produit") !== ""' class="small_alimentation_info">
                <img src="../static/product_type.svg" alt="Icone produit">
                <p>{{getLabels(data["type_de_produit"], "type_de_produit")}}</p>
            </div>
        </div>

        <!-- Bouton de lien vers l'initiative-->
        <button @click="stats(data)"> <a :href='data["media_associe"]' target="_blank"> Voir l'initiative </a></button>
    </div>
</template>

<script>
//import { getFile } from "../utils/requests"
import Store from '../utils/store.js'

var _paq = window._paq || [];
const IMAGE_PATH = {
    "1": "Courses-MangerLocal_1.svg",
    "2": "Scolarité.svg",
    "3": "Administratif.svg",
    "4": "Emploi.svg",
    "5": "FormationCultureActivPhysique.svg"
}

export default {
    name: 'Service',
    props: {
        data: Object
    },
    data: function() {
        return {
            image: null,
            publicPath: process.env.BASE_URL,
            store: Store
        }
    },
    created: function() {
        // TODO : gérer les erreurs
        if(this.data["image"] !== null) {
            this.image = "images/" + this.store.files[this.data["image"]]
        }
    },
    methods: {
        getLabels(keys, field) {
            const labels = [];
            for(const k of keys) {
                if(k === "") {  // peut arriver à cause des bizarreries de Directus
                    continue;
                }
                labels.push(this.getLabel(k, field));
            }
            return labels.join(", ")
        },
        getLabel: function(key, field) {
            return Object.entries(this.store.metadata["fields"][field]["options"]["choices"]).find(x => x[0] === key)[1];
        },
        imagePath: function(data) {
            var id = data["categorie"];
            return IMAGE_PATH[id];
        },
        getPorteur: function(data) {
            return data["porteur_initiative"];
        },
        getCategorie: function(data) {
            return data["categorie"];
        },
        stats: function(data) {
            _paq.push(["trackEvent", "Service", data["titre"]]);
        }
    }
}
</script>

<style scoped>
a{
    color: white;
    text-decoration: none;
}
.service{
    background-color: white;
    padding: 3%;
    margin: 2% 0;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 0px 8px rgba(0, 0, 0, 0.25);
}


h3 {
    text-align: left;
    margin-bottom: 2%;
}

p {
    color: var(--dark-grey);
    text-align: left;
}

.meta_info{
    align-items: center;
    display: flex;
    text-align: left;
}

.meta_info_left{
    float: left;
    width: 50%;
}

.meta_info_left img {
    max-width: 90%;
    max-height: 10vw;
    display:block;
    margin: 5% auto;
}

.meta_info_right{
    float: right;
    width: 50%;
    font-size: 1vw;
}

.meta_info_links{
    display: flex;
    align-items: center;
    width: 100%;
}

.meta_info_links img{
    margin: 0 2%;
}

button{
    background-color: var(--medium-red);
    border: none;
    color: white;
    border-radius: 30px;
    font-size: 1vw;
    font-family: Raleway;
    padding: 1%;
    width: 30%;
    margin-left: 35%;
    margin-top: auto;
    font-weight: bold;
}

.description{
    font-size:1vw;
}

.image_null {
    transform: scale(2, 2);
    filter: invert(16%) sepia(75%) saturate(5920%) hue-rotate(351deg) brightness(95%) contrast(95%);
}

.alimentation_infos{
    display: grid;
    grid-template-columns: repeat(3, 33%);
    margin-bottom: 3%;
}

.small_alimentation_info{
    display: flex;
    justify-content: left;
    align-items: center;
    font-size:1vw;
}

.small_alimentation_info img{
    margin-right: 5%;
}

@media (max-width: 600px) {
    h3 {
        font-size: 3vw;
    }

    .meta_info{
        display: block;
        text-align: left;
    }

    .meta_info_left{
        float: none;
        width: 100%;
    }

    .meta_info_right{
        float: none;
        width: 100%;
    }

    .meta_info_left img {
        max-width: 80%;
    }

    .meta_info_links{
        font-size: 3vw;
    }

    .meta_info_links img{
        width: 3%;
        margin: 0 3% 0 0;
    }
    .meta_info_links p{
        margin: 0;
    }
    .description{
        font-size:3vw;
    }

    button{
        font-size: 3vw;
        width: 40%;
        margin-left: 30%;
    }

    .image_null {
        transform: scale(1, 1);
    }

    .alimentation_infos{
        display: block;
        font-size:3vw;
        margin-bottom: 1%;
    }

    .small_alimentation_info{
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 3vw;
    }

    .small_alimentation_info img{
        width: 3%;
    }

    .small_alimentation_info p{
         margin: 0;
    }
}
</style>
